import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { getRangeFromToLabel } from '@/bundles/GroupFilters/helpers/formatters/range/getRangeFromToLabel';
import { Nullable } from '@/utils/types';
import { getBuildingDimensionFormatted } from '@/bundles/MeasurementUnits/helpers/format/getBuildingDimensionFormatted';

export const getBuildingDimensionRangeFormattedValue = (value: [Nullable<number>, Nullable<number>]): string => {
  const isValuePresentInArray = value.some((v) => isValuePresent(v));

  return isValuePresentInArray ? getRangeFromToLabel(value.map((v) => getBuildingDimensionFormatted(v))) : '';
}
